import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";
import {
  Gifts,
  Delivery,
  Vip,
  Cashback,
  Coupons,
  Chat,
} from "../../../../../assets/images/index";
import Lottie from "react-lottie-player";
import "./rewards.scss";

export const Rewards = () => {
  const Data = [
    { image: Coupons, title: "Discount Coupons" },
    { image: Gifts, title: "Gifts" },
    { image: Delivery, title: "Free Delivery" },
    { image: Cashback, title: "Cashback" },
    { image: Vip, title: "Exclusive Access" },
  ];
  return (
    <section className="reward-session" > 
      <div className="chat-lottie-animation d-flex justify-content-center">
        <Lottie
          loop
          animationData={Chat}
          play
          style={{ width: "400px", height: "100%" }}
          
        />
      </div>

      <div
        className="make-offers-title fw-bold text-center "
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="500"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        id="reward-main-section"
        
      >
        Sit back and let sellers make you offers!
      </div>
      <div
        className="make-offers-body text-center fw-bold mt-5"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="500"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        
      >
        Get incredible offers from different sellers, negotiate like a pro,and
        seal the deal with a satisfying tap to get your dream item delivered to
        your doorstep with Pamo riders! 🛍️🤝🚚
      </div>

      <Row className="rewards-container">
        <div
          className="rewards-header fw-bold text-center mt-5"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="500"
          data-aos-once="false"
          data-aos-anchor-placement="top-center"
        >
          The rewards are endless!
        </div>
        <div className="rewards-body text-center fw-light mt-3"
        data-aos="flip-down"
        data-aos-easing="linear"
        data-aos-duration="500"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        >
          Journey with Pamo, earn points, Redeem as Rewards!s
        </div>
        <Col className="d-flex flex-nowarap overflow-auto rewards-slide">
          {Data.map((item, key) => (
            <div className="reward-items mx-3" key={key}>
              <Image src={item.image} className="reward-slide-image" 
              data-aos="flip-right"
              data-aos-easing="linear"
              data-aos-duration="700"
              data-aos-once="false"
              data-aos-anchor-placement="top-center"
              />
              <div className="reward-slide-image-text text-black text-center mt-2 fw-light"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="900"
              data-aos-once="false"
             >
                {item.title}
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </section>
  );
};
